import { initAdv, injectAdv } from '@sky-uk/sky-adv';
import intersect from './intersect';

const STARTING_GRID_SELECTOR = '.ftbl__drivers-starting-grid__cards-row';
const ADV_CONTENT_SELECTOR = '.ftbl__card-adv';
const ROW_VISIBLE_CLASS = 'ftbl__drivers-starting-grid__cards-row--visible';
const ROW_ANIMATED_CLASS = 'ftbl__drivers-starting-grid__cards-row--animated';
const gridSelector = document.querySelector(STARTING_GRID_SELECTOR);

const startingGrid = () => { 
  if (gridSelector) {
    observeStartingGrid();
  }
}

const observeStartingGrid = (): void => {
  const setup = intersect(STARTING_GRID_SELECTOR, 0);
  const advSetup = intersect(ADV_CONTENT_SELECTOR, 0);
  const container = Array.from(document.querySelectorAll(STARTING_GRID_SELECTOR));

  setup((visibleEl: Element | null) => {
    const id = visibleEl && visibleEl.getAttribute('data-index');

    if (visibleEl && !visibleEl.classList.contains(ROW_VISIBLE_CLASS)) {
      visibleEl.setAttribute('data-visible', 'true'),
      visibleEl.classList.add(ROW_ANIMATED_CLASS)

      /* Removes visible class to elements above the observer target */
      const idNum = Number(id);
      if (idNum && idNum > 0) {
        container.forEach(item => {
          const itemId = Number(item.getAttribute('data-index'));
          if (itemId && itemId < idNum || itemId === 0) {
            item.setAttribute('data-visible', 'true');
            (item as HTMLElement).className = `ftbl__drivers-starting-grid__cards-row ${ROW_VISIBLE_CLASS}`;
          }
        });
      }
    }

    /* Adds analytics track to card_rows that enter the viewport */
    visibleEl && (window as any)._satellite.track("change_gallery", { hash: id });
  });

  /* Removes animation class to elements above the viewport */
  const VIEWPORT_OFFSET = 150;
  container.forEach(item => {
    const el = item as HTMLElement;
    const rect = el.getBoundingClientRect();

    if (rect.bottom <= VIEWPORT_OFFSET) {
      el.classList.add(ROW_VISIBLE_CLASS);
      el.classList.remove(ROW_ANIMATED_CLASS);
      el.setAttribute('data-visible', 'true');
    }
  });

  /* Injects ads into the visible elements */
  advSetup((visibleEl: Element | null) => {
    if (visibleEl) {
      const adv = visibleEl.querySelector('[data-adv-content]') as HTMLElement | null;

      if (adv && !adv?.querySelector('ins')) {
        injectAdv(adv);
        initAdv(adv);
      }
    }
  });
};

export default startingGrid;